export default __webpack_public_path__ + "static/media/gallery_06.583c2832.jpg";